export { StoreCache, IStoreCacheOptions } from "./StoreCache";
